import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { Icon } from '../../../components/Icon'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import {
  getCategoriesData,
  getCategoriesDataById,
  getResourcesDataById,
} from './api.call'
import { downloadPDF } from '../../policy/utils'
import { toast } from 'react-toastify'

const CandidateResources = () => {
  const [isView, setIsView] = useState<string>('categories')
  const [categoryName, setCategoryName] = useState('')
  const [categoryId, setCategoryId] = useState('')

  const Categories = useQuery('categories', () => getCategoriesData(1))
  const categoriesById = useQuery(
    ['categoriesById', categoryId],
    () => getCategoriesDataById(categoryId, 1),
    {
      enabled: !!categoryId, // Only fetch data when id is truthy
    }
  )

  const resourcesById = useQuery(
    ['resources', categoryId],
    () => getResourcesDataById(categoryId),
    {
      enabled: !!categoryId, // Only fetch data when id is truthy
    }
  )

  return (
    <>
      {isView == 'categories' && (
        <div
          className={'flex flex-col w-full bg-white  h-full rounded-3xl p-8 '}
        >
          <div className="flex flex-col w-full relative h-full">
            <div className={'flex w-full justify-between items-start '}>
              <div className="flex-col w-[50%] gap-[20px]">
                <p className={'text-[18px] text-text2 font-bold '}>Resources</p>
              </div>
            </div>
            {/* content container */}
            <div className="flex flex-col gap-4 mt-8">
              {Categories?.data?.data?.map((item, index) => (
                <>
                  <div
                    key={index}
                    onClick={() => {
                      setIsView('subCategories')
                      setCategoryId(item.id)
                      setCategoryName(item.name)
                    }}
                    className="flex items-center cursor-pointer border border-gray3 p-4 px-5 rounded-2xl gap-3"
                  >
                    <Icon
                      name="IconFolder"
                      width={24}
                      height={24}
                      strokeWidth={1}
                      stroke={'#02698C'}
                    />
                    <p className="text-sm font-semibold leading-6 text-text2 flex-1">
                      {item.name}
                    </p>
                    <div className="flex gap-2">
                      <Icon
                        name="IconList"
                        width={24}
                        height={24}
                        strokeWidth={2}
                        stroke={'#02698C'}
                      />
                      <p className="text-sm font-semibold leading-6 text-text1">
                        Categories:
                      </p>
                      <p className="text-sm font-semibold leading-6 text-text2">
                        {item.sub_categories}
                      </p>
                    </div>
                    <div className="flex gap-2 ml-3">
                      <Icon
                        name="IconFile"
                        width={24}
                        height={24}
                        strokeWidth={1.2}
                        stroke={'#02698C'}
                      />
                      <p className="text-sm font-semibold leading-6 text-text1">
                        Resources:
                      </p>
                      <p className="text-sm font-semibold leading-6 text-text2">
                        {item.resources}
                      </p>
                    </div>
                    <div className="ml-3">
                      <Icon
                        name="IconChevronRight"
                        width={12}
                        height={12}
                        strokeWidth={1}
                        stroke={'#02698C'}
                      />
                    </div>
                  </div>
                </>
              ))}
            </div>

            {/* <div className="absolute bottom-2">
             
              <Pagination
                currentPage={currentPage}
                totalPages={calculatePageCount(
                  Categories?.data?.data?.length || 0
                )}
                onPageChange={handlePageChange}
              />
            </div> */}
          </div>
        </div>
      )}
      {isView == 'subCategories' && (
        <div
          className={
            'flex flex-col gap-2 w-full bg-white  h-full rounded-3xl p-5 '
          }
        >
          <UISubHeaderComponent
            mainPage="Resources"
            subPage={categoryName}
            // copy="Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor."
            onDelete={() => {}}
            isViewMode={false}
            isCreatePolicy={false}
            onBack={() => {
              setIsView('categories')
            }}
            customDescriptionStyle={{ width: '68%' }}
          />
          {/* content container */}
          <div
            style={{
              height: 'calc(100vh - 100px)',
              overflowY: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col gap-4 mt-4"
          >
            <div className="flex items-center gap-3">
              <p className="text-sm text-text2 font-semibold leading-6">
                Sort by
              </p>
              <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
                <p className={'text-text1 font-medium text-xs leading-5'}>
                  Last Added
                </p>
                <Icon
                  name="IconChevronDown"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#67A5B9'}
                />
              </div>
            </div>
            {categoriesById?.data?.data?.map((item, index) => (
              <>
                <div
                  key={index}
                  onClick={() => {
                    setCategoryId(item?.id)
                    setIsView('subCategoriesDocument')
                  }}
                  className="flex items-center cursor-pointer border border-gray3 p-4 px-5 rounded-2xl gap-3"
                >
                  <Icon
                    name="IconFolder"
                    width={24}
                    height={24}
                    strokeWidth={1}
                    stroke={'#02698C'}
                  />
                  <p className="text-sm font-semibold leading-6 text-text2 flex-1">
                    {item.name}
                  </p>
                  <div className="flex gap-2">
                    <Icon
                      name="IconList"
                      width={24}
                      height={24}
                      strokeWidth={2}
                      stroke={'#02698C'}
                    />
                    <p className="text-sm font-semibold leading-6 text-text1">
                      Categories:
                    </p>
                    <p className="text-sm font-semibold leading-6 text-text2">
                      {item.sub_categories}
                    </p>
                  </div>
                  <div className="flex gap-2 ml-3">
                    <Icon
                      name="IconFile"
                      width={24}
                      height={24}
                      strokeWidth={1.2}
                      stroke={'#02698C'}
                    />
                    <p className="text-sm font-semibold leading-6 text-text1">
                      Resources:
                    </p>
                    <p className="text-sm font-semibold leading-6 text-text2">
                      {item.resources}
                    </p>
                  </div>
                  <div className="ml-3">
                    <Icon
                      name="IconChevronRight"
                      width={12}
                      height={12}
                      strokeWidth={1}
                      stroke={'#02698C'}
                    />
                  </div>
                </div>
              </>
            ))}
            <div>
              <p className="text-sm text-text2 font-semibold leading-6">
                Category Documents
              </p>
            </div>
            {resourcesById?.data?.data?.map((item, index) => (
              <>
                <div
                  key={index}
                  onClick={() => {
                    if (!item.downloadUrl) return

                    if (
                      (item.downloadUrl as unknown as string) == 'IN PROGRESS'
                    ) {
                      return toast.warning(
                        'Scanning the file, please check again in a few seconds.',
                        {
                          position: 'top-right',
                        }
                      )
                    }
                    if (
                      (item.downloadUrl as unknown as string) == 'NoSuchKey'
                    ) {
                      return toast.warning('File is removed', {
                        position: 'top-right',
                      })
                    }
                    downloadPDF(item.downloadUrl, 'document.pdf')
                  }}
                  className="py-3 px-4 flex gap-3 items-center w-full bg-gray1 rounded-xl cursor-pointer"
                >
                  <Icon
                    name="IconFile"
                    width={16}
                    height={16}
                    strokeWidth={1.5}
                    stroke={'#02698C'}
                  />
                  <label
                    className={`text-sm font-semibold leading-6 text-bluishGreen flex-1 cursor-pointer`}
                  >
                    {item.name}
                    <span className="text-xs font-medium leading-5 text-text3">
                      1.7 MB
                    </span>
                  </label>
                  <div>
                    <Icon
                      name="IconDownloadCloud"
                      width={16}
                      height={16}
                      strokeWidth={1.1}
                      stroke={'#02698C'}
                    />
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
      {isView == 'subCategoriesDocument' && (
        <div
          className={
            'flex flex-col gap-2 w-full bg-white  h-full rounded-3xl p-5 '
          }
        >
          <UISubHeaderComponent
            mainPage="..."
            subPage={categoryName || 'Sub Category Name'}
            // copy="Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor."
            onDelete={() => {}}
            isViewMode={false}
            isCreatePolicy={false}
            customDescriptionStyle={{ width: '68%' }}
            onBack={() => {
              setIsView('categories')
            }}
          />

          <div
            style={{
              height: 'calc(100vh - 100px)',
              overflowY: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col gap-4 mt-4"
          >
            <div className="flex items-center gap-3">
              <p className="text-sm text-text2 font-semibold leading-6">
                Sort by
              </p>
              <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
                <p className={'text-text1 font-medium text-xs leading-5'}>
                  Last Added
                </p>
                <Icon
                  name="IconChevronDown"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#67A5B9'}
                />
              </div>
            </div>
            {categoriesById?.data?.data?.map((item, index) => (
              <>
                <div
                  key={index}
                  onClick={() =>
                    // setIsView('subCategoriesDocument')
                    setCategoryId(item?.id)
                  }
                  className="flex items-center cursor-pointer border border-gray3 p-4 px-5 rounded-2xl gap-3"
                >
                  <Icon
                    name="IconFolder"
                    width={24}
                    height={24}
                    strokeWidth={1}
                    stroke={'#02698C'}
                  />
                  <p className="text-sm font-semibold leading-6 text-text2 flex-1">
                    {item.name}
                  </p>
                  <div className="flex gap-2">
                    <Icon
                      name="IconList"
                      width={24}
                      height={24}
                      strokeWidth={2}
                      stroke={'#02698C'}
                    />
                    <p className="text-sm font-semibold leading-6 text-text1">
                      SubCategories:
                    </p>
                    <p className="text-sm font-semibold leading-6 text-text2">
                      {item.sub_categories}
                    </p>
                  </div>
                  <div className="flex gap-2 ml-3">
                    <Icon
                      name="IconFile"
                      width={24}
                      height={24}
                      strokeWidth={1.2}
                      stroke={'#02698C'}
                    />
                    <p className="text-sm font-semibold leading-6 text-text1">
                      Resources:
                    </p>
                    <p className="text-sm font-semibold leading-6 text-text2">
                      {item.resources}
                    </p>
                  </div>
                  <div className="ml-3">
                    <Icon
                      name="IconChevronRight"
                      width={12}
                      height={12}
                      strokeWidth={1}
                      stroke={'#02698C'}
                    />
                  </div>
                </div>
              </>
            ))}
            <div>
              <p className="text-sm text-text2 font-semibold leading-6">
                SubCategory Documents
              </p>
            </div>
            {resourcesById?.data?.data?.map((item, index) => (
              <>
                <div
                  key={index}
                  onClick={() => {
                    if (!item.downloadUrl) return

                    if (
                      (item.downloadUrl as unknown as string) == 'IN PROGRESS'
                    ) {
                      return toast.warning(
                        'Scanning the file, please check again in a few seconds.',
                        {
                          position: 'top-right',
                        }
                      )
                    }
                    if (
                      (item.downloadUrl as unknown as string) == 'NoSuchKey'
                    ) {
                      return toast.warning('File is removed', {
                        position: 'top-right',
                      })
                    }

                    downloadPDF(item.downloadUrl, 'document.pdf')
                  }}
                  className="py-3 px-4 flex gap-3 items-center w-full bg-gray1 rounded-xl cursor-pointer"
                >
                  <Icon
                    name="IconFile"
                    width={16}
                    height={16}
                    strokeWidth={1.5}
                    stroke={'#02698C'}
                  />
                  <label
                    className={`text-sm font-semibold leading-6 text-bluishGreen flex-1 cursor-pointer`}
                  >
                    {item.name}
                    <span className="text-xs font-medium leading-5 text-text3">
                      1.7 MB
                    </span>
                  </label>
                  <div>
                    <Icon
                      name="IconDownloadCloud"
                      width={16}
                      height={16}
                      strokeWidth={1.1}
                      stroke={'#02698C'}
                    />
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default CandidateResources
